import WarningIcon from '@atlaskit/icon/core/warning';
import { Flex } from '@atlaskit/primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AccordionError = _ref => {
  let {
    label,
    message
  } = _ref;
  const errorMessage = message || 'We’re having trouble loading, refresh to try again.';
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "space.050",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(WarningIcon, {
      label: label,
      color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/_jsx("div", {
      children: errorMessage
    })]
  });
};